/* eslint-disable react/prop-types */
import PropTypes from 'prop-types';
import constants from '../../../config/constants';
import { withApplicationContext } from '../../../utils/ApplicationContext';
import _ from '../../../utils/LodashImports';
import MyLists from '../../MyLists/MyLists';
import { ProductShareIcon } from '../../PDP';
import { ImageGalleryAdditionalButtonsStyles } from './ImageGalleryAdditionalButtons.style';

const ImageGalleryAdditionalButtons = ({
  appCtx,
  productId,
  variantId,
  offeringId,
  showMyList,
  page,
  isOutOfStock,
}) => {
  const isPDP = page === constants.PAGES.PDP;
  const isMyListsEnabled = _.get(appCtx, 'siteConfig.toggles.isPDPMyListsEnabled', false) && showMyList;
  const shouldShowMyLists = isPDP && isMyListsEnabled && !isOutOfStock;
  const shouldShowShareIcon = isPDP && !isOutOfStock;
  if (isOutOfStock || !isPDP || (!shouldShowMyLists && !shouldShowShareIcon)) {
    return null;
  }

  return (
    <div className="image-gallery-additional-buttons">
      {shouldShowMyLists && (
        <div
          className="button-container mylists-container"
          onKeyDown={(e) => {
            e.stopPropagation();
          }}
          role="button"
          tabIndex={0}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <MyLists
            appCtx={appCtx}
            product={{
              productId,
              variantId,
              offeringId,
            }}
            isPDPpage
          />
        </div>
      )}

      {shouldShowShareIcon && (
        <div className="button-container share-container">
          <ProductShareIcon />
        </div>
      )}

      <style jsx>{ImageGalleryAdditionalButtonsStyles}</style>
    </div>
  );
};

ImageGalleryAdditionalButtons.defaultProps = {
  productId: '',
  variantId: '',
  offeringId: '',
  showMyList: true,
  page: 'PDP',
  isOutOfStock: false,
};

ImageGalleryAdditionalButtons.propTypes = {
  appCtx: PropTypes.object.isRequired,
  productId: PropTypes.string,
  variantId: PropTypes.string,
  offeringId: PropTypes.string,
  showMyList: PropTypes.bool,
  page: PropTypes.string,
  isOutOfStock: PropTypes.bool,
};

export default withApplicationContext(ImageGalleryAdditionalButtons);
export { ImageGalleryAdditionalButtons };
